export default __webpack_public_path__ + "locales/pt/DeleteProfileEverDialog.json?hash=fa8bb9072307593c7965f63b649ba8e1";